export enum VolumeStreamEvents {
  Loaded       = 'loaded',
  Unloaded     = 'unloaded',
  Connected    = 'connected',
  Disconnected = 'disconnected',
  Restarted    = 'restarted',
}
